import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { sanitizeFilters } from "@/helpers/request-helpers";
import { IServiceInterfaceLog } from "@/interfaces/service-interface.interface";
import serviceInterfaceLogService from "@/services/service-interface-log.service";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination, RequestsBaseReturn } from "@/types/requests.types";

export interface Props extends RequestPagination {
  serviceInterfaceId: number;
  filters: IFilter<IServiceInterfaceLog>[];
  enabled: boolean;
}

type GetAllSwrParams = [string, number, number, number, IFilter<IServiceInterfaceLog>[]];

export type Return = RequestsBaseReturn<PaginatedResponse<IServiceInterfaceLog> | null>;

const useGetServiceInterfaceLogs = ({
  serviceInterfaceId,
  pageNumber,
  pageSize,
  filters,
  enabled,
}: Props): Return => {
  const activeFilters = sanitizeFilters(filters);

  const fetcher = useSWR<PaginatedResponse<IServiceInterfaceLog>, Error, GetAllSwrParams | null>(
    enabled
      ? [SWR_KEYS.getServiceInterfaceLogs, serviceInterfaceId, pageNumber, pageSize, activeFilters]
      : null,
    ([, id, _pageNumber, _pageSize, _filters]) =>
      serviceInterfaceLogService.filter(id, _filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetServiceInterfaceLogs;
